import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import TableListFooter from '../components/TableListFooter';
import {
  fetchAnketKampanyalari,
  createAnketKampanya,
  fetchAnketAlicilar,
} from '../services/anketService';
import './AnketlerPage.css';

const tarihYaz = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('tr-TR');
};

export default function AnketKampanyalarPage() {
  const [hedef, setHedef] = useState('bayi');
  const [baslik, setBaslik] = useState('');
  const [baslangic, setBaslangic] = useState('');
  const [bitis, setBitis] = useState('');
  const [arama, setArama] = useState('');
  const [sonuclar, setSonuclar] = useState([]);
  const [secilenler, setSecilenler] = useState([]);
  const [tumunu, setTumunu] = useState(false);
  const [liste, setListe] = useState([]);
  const [sayfa, setSayfa] = useState(1);
  const [sayfalama, setSayfalama] = useState({ toplam: 0, toplamSayfa: 1, mevcutSayfa: 1 });
  const [hata, setHata] = useState('');
  const [mesaj, setMesaj] = useState('');

  const kampanyalariYukle = async (s) => {
    const res = await fetchAnketKampanyalari(s);
    setListe(res?.veri?.kayitlar || []);
    setSayfalama(res?.veri?.sayfalama || { toplam: 0, toplamSayfa: 1, mevcutSayfa: 1 });
  };

  useEffect(() => {
    kampanyalariYukle(sayfa).catch((err) => setHata(err?.message || 'Liste alınamadı'));
  }, [sayfa]);

  useEffect(() => {
    const q = arama.trim();
    if (q.length < 3) {
      setSonuclar([]);
      return undefined;
    }
    const t = setTimeout(() => {
      fetchAnketAlicilar({ hedef, q })
        .then((res) => setSonuclar(res?.veri || []))
        .catch(() => setSonuclar([]));
    }, 250);
    return () => clearTimeout(t);
  }, [hedef, arama]);

  const sec = (kisi) => {
    if (tumunu) return;
    setSecilenler((prev) => (prev.some((p) => p.id === kisi.id) ? prev : [...prev, { id: kisi.id, ad: kisi.ad }]));
  };

  const kaldir = (id) => {
    setSecilenler((prev) => prev.filter((p) => p.id !== id));
  };

  const tumunuSec = () => {
    setSecilenler([]);
    setTumunu(true);
    setSonuclar([]);
    setArama('');
  };

  const tumunuKaldir = () => setTumunu(false);

  const olustur = async (e) => {
    e.preventDefault();
    setHata('');
    setMesaj('');
    try {
      const res = await createAnketKampanya({
        hedef,
        baslik,
        baslangic: baslangic || undefined,
        bitis,
        aliciIdler: tumunu ? [] : secilenler.map((s) => s.id),
        tumunu,
      });
      const veri = res?.veri || {};
      setMesaj(`${veri.davetSayisi || 0} davet`);
      setBaslik('');
      setSecilenler([]);
      setTumunu(false);
      setArama('');
      setSonuclar([]);
      setSayfa(1);
      await kampanyalariYukle(1);
    } catch (err) {
      setHata(err?.message || 'Kampanya oluşturulamadı');
    }
  };

  return (
    <main className="main-content anketler-sayfa">
      <div className="content-header">
        <div>
          <h1>Kampanyalar</h1>
        </div>
        <div className="content-header-actions">
          <Link className="secondary-btn" to="/anketler">Anketler</Link>
        </div>
      </div>
      <form className="anket-form" onSubmit={olustur}>
        <label>
          Hedef
          <select value={hedef} onChange={(e) => { setHedef(e.target.value); setSecilenler([]); setTumunu(false); setArama(''); setSonuclar([]); }}>
            <option value="bayi">Bayi</option>
            <option value="teknik_servis">Teknik servis</option>
          </select>
        </label>
        <label>
          Başlık
          <input value={baslik} onChange={(e) => setBaslik(e.target.value)} required maxLength={120} />
        </label>
        <label>
          Başlangıç
          <input type="date" value={baslangic} onChange={(e) => setBaslangic(e.target.value)} />
        </label>
        <label>
          Bitiş
          <input type="date" value={bitis} onChange={(e) => setBitis(e.target.value)} required />
        </label>
        <div className="anket-alicilar">
          <div className="anket-ara-satir">
            <label>
              Alıcı ara
              <input value={arama} onChange={(e) => setArama(e.target.value)} autoComplete="off" />
            </label>
            <button type="button" className="secondary-btn" onClick={tumunuSec} disabled={tumunu}>Tümü</button>
          </div>
          {sonuclar.length > 0 && (
            <ul className="anket-sonuc-liste">
              {sonuclar.map((a) => {
                const secili = tumunu || secilenler.some((s) => s.id === a.id);
                return (
                  <li key={a.id}>
                    <span>{a.ad}</span>
                    <button type="button" className="secondary-btn" disabled={secili} onClick={() => sec(a)}>Seç</button>
                  </li>
                );
              })}
            </ul>
          )}
          <div className="anket-secilenler">
            <span className="anket-secilen-baslik">Seçilenler</span>
            {tumunu ? (
              <div className="anket-secilen-satir">
                <span>Tümü</span>
                <button type="button" className="secondary-btn" onClick={tumunuKaldir}>Kaldır</button>
              </div>
            ) : secilenler.map((s) => (
              <div key={s.id} className="anket-secilen-satir">
                <span>{s.ad}</span>
                <button type="button" className="secondary-btn" onClick={() => kaldir(s.id)}>Kaldır</button>
              </div>
            ))}
          </div>
        </div>
        {hata ? <p>{hata}</p> : null}
        {mesaj ? <p>{mesaj}</p> : null}
        <button type="submit" className="primary-btn" disabled={!tumunu && secilenler.length === 0}>Oluştur</button>
      </form>
      <div className="card">
        <table className="admins-table anket-tablo">
          <thead>
            <tr>
              <th>Başlık</th>
              <th>Hedef</th>
              <th>Süre</th>
              <th>Cevap</th>
            </tr>
          </thead>
          <tbody>
            {liste.map((k) => (
              <tr key={k.id}>
                <td>{k.baslik}</td>
                <td>{k.hedef === 'bayi' ? 'Bayi' : 'Teknik servis'}</td>
                <td>{tarihYaz(k.baslangic)} – {tarihYaz(k.bitis)}</td>
                <td>{k.cevap}/{k.davet}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <TableListFooter
          totalRecords={sayfalama.toplam}
          currentPage={sayfalama.mevcutSayfa}
          totalPages={sayfalama.toplamSayfa}
          onPageChange={setSayfa}
          embedded
        />
      </div>
    </main>
  );
}
